import { i18n } from "@/utils/i18n";

export default {
  namespaced: true,
  state: {
    endpoint: "/client/custom/lamcom/hive/work_orders/dashboard_widget",
    fetchKey: "work_orders",
    permissionKey: ""
  },
  mutations: {},
  actions: {},
  getters: {}
};
